import {
  ActiveStudioIcon,
  PlatformAndroidIcon,
  PlatformIosIcon,
  PlatformStudioIcon,
} from "icons";
import { CaptureCard } from "../captureCard";
import styles from "./styles.module.scss";
import {
  AndroidIcon,
  IOSIcon,
  StudioIcon,
} from "pages/internal-dashboard/iconComponents";
import { IsoIcon } from "pages/history/filterV1/filterModalV1/icons";
import {
  AndroidInActiveIcon,
  IosInActiveIcon,
  StudioInActiveIcon,
} from "pages/m2c-simulation/icons";

export const CaptureCards = ({ captureCounts, capturePercentage }) => {
  const { android, ios, studio, total } = captureCounts || {};
  const {
    android: androidPercentage,
    ios: iosPercentage,
    studio: studioPercentage,
  } = capturePercentage || {};
  const list = [
    {
      title: "Total Captures",
      value: total,
      percentage: "100%",
      icon: null,
      bgColor: "#EDEEFC",
      increase: true,
    },
    {
      title: "Studio",
      value: studio,
      percentage: `${studioPercentage}%`,
      icon: PlatformStudioIcon,
      bgColor: "#E6F1FD",
      increase: false,
    },
    {
      title: "Android",
      value: android,
      percentage: `${androidPercentage}%`,
      icon: PlatformAndroidIcon,
      bgColor: "#EDEEFC",
      increase: true,
    },
    {
      title: "iOS",
      value: ios,
      percentage: `${iosPercentage}%`,
      icon: PlatformIosIcon,
      bgColor: "#E6F1FD",
      increase: true,
    },
  ];

  return (
    <div className={styles.totalCaptures}>
      {list.map((item) => (
        <CaptureCard key={item.title} item={item} />
      ))}
    </div>
  );
};
